import React from 'react';
import UserGroupLabel from 'components/UserGroupLabel/UserGroupLabel';
import { EllipsisElement } from 'components/EllipsisElement/EllipsisElement';
import { getGroupName } from 'modules/get-group-name/get-group-name';
import { Popup } from 'semantic-ui-react';

export const getColumns = (groups, renderActions = () => {}) => [
  {
    Header: 'E-mail',
    disableSortBy: true,
    accessor: 'email',
    width: 155,
    Cell: ({ value }) => value && <EllipsisElement>{value}</EllipsisElement>,
  },
  {
    Header: 'Username',
    disableSortBy: true,
    accessor: 'username',
    width: 155,
    Cell: ({ value }) => value && <EllipsisElement>{value}</EllipsisElement>,
  },
  {
    Header: 'Grupo',
    disableSortBy: true,
    accessor: 'group_id',
    textAlign: 'center',
    width: 60,
    Cell: ({ value }) =>
      value && <UserGroupLabel groupName={getGroupName(value, groups)} />,
  },
  {
    Header: 'Almacén',
    disableSortBy: true,
    accessor: 'warehouse',
    width: 120,
    textAlign: 'center',
    Cell: ({ value }) => value?.warehouse || '',
  },
  {
    Header: 'Marketplace',
    disableSortBy: true,
    accessor: 'marketplaces',
    width: 120,
    textAlign: 'center',
    Cell: ({ value }) => {
      const marketplaces = new Intl.ListFormat('es', {
        type: 'conjunction',
      }).format(value?.map((marketplace) => marketplace.name) || []);

      return (
        value && (
          <Popup
            className="base-tooltip"
            trigger={
              <div style={{ width: '100%' }}>
                <EllipsisElement>{marketplaces}</EllipsisElement>
              </div>
            }
            content={<div>{marketplaces}</div>}
          />
        )
      );
    },
  },
  {
    Header: 'Acciones',
    disableSortBy: true,
    textAlign: 'right',
    width: 80,
    Cell: ({ row }) => {
      return renderActions(row.original);
    },
  },
];
